/*
*###############################################################################
*Module Name                   : DPNavBar.js                                   #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Tuesday, August 24th 2021, 1:47:16 pm         #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useState } from 'react';
import { Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"

const DPNavBar = (props) => {
    const btns = props.buttons;
    var btnList = btns != null || btns.count > 1 ? btns : [];
    return (
        <Nav tabs className="nav-tabs-custom nav-justified">
            {btnList.map((btn, i = 0) => {
                i++;
                return (
                    <NavItem>
                        <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                                active: props.activeStatus === btn.tabID,
                            })}
                            onClick={btn.onClick}
                        >
                            <span className="d-block d-sm-none">
                                <i className={btn.icon}></i>
                            </span>
                            <span className="d-none d-sm-block">{btn.text}</span>
                        </NavLink>
                    </NavItem>
                )
            })}
        </Nav>
    );
}

export default DPNavBar;